export default "dist/images/block-container-image2.7523704.png";